import VideoJS from 'video.js';

import * as Controls from '../../ui/UIControlsNames';

const TimeDisplay = VideoJS.getComponent('TimeDisplay');

class ASAdCountdown extends TimeDisplay {
    buildCSSClass() {
        return `as-ad-countdown vjs-ad-countdown ${super.buildCSSClass()}`.trim();
    }

    slot(slot) {
        if (slot === undefined) {
            return this.slot_ || undefined;
        }
        this.slot_ = slot || undefined;
    }

    timeRemaining(timeRemaining) {
        if (timeRemaining === undefined) {
            return this.timeRemaining_ || undefined;
        }
        this.timeRemaining_ = timeRemaining || undefined;
    }

    updateContent(event) {
        if (this.slot_) {
            if (this.slot_.getTotalDuration) {
                const totalAdDuration = Math.round(this.slot_.getTotalDuration());
                const timeRemaining = totalAdDuration - Math.round(this.slot_.getPlayheadTime());
                this.updateFormattedTime_(timeRemaining);
            }
        }
        if (this.timeRemaining_) {
            this.updateFormattedTime_(this.timeRemaining_);
        }
    }
}

ASAdCountdown.prototype.labelText_ = 'Ad:';
ASAdCountdown.prototype.controlText_ = 'Ad';

VideoJS.registerComponent(Controls.AD_COUNTDOWN, ASAdCountdown);

export default ASAdCountdown;



// WEBPACK FOOTER //
// ./src/player/components/ASAdCountdown.js